const BuyersIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg"
            width="24" height="24" viewBox="0 0 100 100">
            <g>
                <circle cx="58.7" cy="76.7" r="2.2" />
                <circle cx="69.5" cy="76.7" r="2.2" />
                <path d="M37.3,43.1c-1.5-2.4-2.4-5.2-2.4-8.3c0-5.2,2.2-9.6,5.7-12.2c-1.3-2.2-3.5-3.6-6.6-3.6
                c-5.1,0-7.9,4.1-7.9,8.8c0,2.6,0.9,4.7,2.6,6.3c1,0.9,1.8,2,1.8,3.3c0,1.2-0.4,2.3-3.3,3.5c-4.1,1.9-7.9,4.2-8,8.1
                c0,2.6,1.7,4.4,4.1,4.4h3.8c0.6,0,1.2-0.4,1.5-0.9c1.9-3.3,5.3-5.5,8.2-6.9C37.5,45.1,37.9,43.9,37.3,43.1z"/>
                <path d="M58.4,66.4h13.3c0.4,0,0.8-0.3,0.8-0.7l2.4-8.6c0.2-0.6-0.3-1.1-0.8-1.1H60h-6.4l-0.3-1.3
                c-0.2-0.6-0.7-1-1.3-1h-2.2c-0.7,0-1.4,0.6-1.4,1.3c-0.1,0.8,0.6,1.4,1.3,1.4H51l1.2,4l0,0l3,10.3c0.2,0.6,0.7,1,1.3,1h15.6
                c0.7,0,1.4-0.6,1.4-1.3c0.1-0.8-0.6-1.4-1.3-1.4H58.4c-0.6,0-1.1-0.4-1.3-0.9V68C56.9,67.2,57.5,66.4,58.4,66.4z"/>
                <path d="M48.4,61.6l-0.4-1.5c-0.9-0.3-1.6-0.8-2.2-1.5c-0.9-1.1-1.4-2.4-1.3-3.8c0.1-2.8,2.6-5,5.4-5H52
                c1.8,0,3.4,0.9,4.4,2.3H60h2.1c-1.6-1.1-3.5-2-5.4-2.8c-3.2-1.3-3.6-2.6-3.6-3.9c0-1.3,0.9-2.6,1.9-3.6c1.9-1.7,2.9-4.1,2.9-7
                c0-5.2-3.2-9.7-8.8-9.7s-8.8,4.5-8.8,9.7c0,2.8,1.1,5.2,2.9,7c1.1,1,1.9,2.3,1.9,3.6c0,1.3-0.5,2.6-3.6,3.9
                c-4.8,1.9-9.2,4.2-9.3,8.5c0,2.8,2,5.3,4.7,5.3h11.8L48.4,61.6z"/>
                <path d="M63.1,34.8c0,3.1-0.8,5.9-2.4,8.3c-0.6,0.9-0.3,2,0.7,2.6c2.8,1.3,6,3.3,7.9,6.4h4.8c1,0,1.9,0.3,2.7,0.9
                c1.3-0.7,2.1-2.1,2.1-3.9c-0.1-3.9-3.9-6.3-8-8.2c-2.9-1.2-3.3-2.4-3.3-3.5c0-1.2,0.8-2.4,1.8-3.3c1.7-1.6,2.6-3.7,2.6-6.3
                c0-4.8-2.8-8.8-7.9-8.8c-3.1,0-5.3,1.4-6.6,3.6C60.9,25.2,63.1,29.5,63.1,34.8z"/>
            </g>
        </svg>
    );
}

export default BuyersIcon;